<template>
  <el-dialog
    :title="actionTypeName + ' ' + typeName"
    width="60%"
    visible
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
    class="dialog"
  >
  <!-- для работы с деревом конфигурации И справочниками -->
    <server v-if="type==='server'" :type="formActionType" @data="dataRecieved" @close="close"></server>
    <my-section
      v-else-if="type==='app'"
      :type="formActionType"
      :fromReference="fromReference"
      @data="dataRecieved"
      @close="close"
    ></my-section>
    <d-base
      v-else-if="type==='db'"
      :type="formActionType"
      :fromReference="fromReference"
      @data="dataRecieved"
      @close="close"
    ></d-base>
    <my-param
      v-else-if="type==='app param'"
      :type="formActionType"
      @data="dataRecieved"
      @close="close"
    ></my-param>
    <!-- для работы только со справочниками  -->
    <user v-else-if="type==='user'" :type="formActionType" @data="dataRecieved" @close="close"></user>
    <task v-else-if="type==='task'" :type="formActionType" @data="dataRecieved" @close="close"></task>
    <app-param
      v-else-if="type==='param'"
      :type="formActionType"
      @data="dataRecieved"
      @close="close"
    ></app-param>
    <role v-else-if="type==='role'" :type="formActionType" @data="dataRecieved" @close="close"></role>
  </el-dialog>
</template>



<script>
import Server from "./Server";
import Section from "./Section";
import DBase from "./DBase";
import Param from "./Param";
import User from "./User";
import Task from "./Task";
import AppParam from "./AppParam";
import Role from "./Role";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      typeName: "",
      actionTypeName: "",
    };
  },
  props: {
    formActionType: {
      default: "Название формы",
    },
    type: {
      type: String,
      required: true,
    },
    fromReference: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dataRecieved(value) {
      if (this.formActionType === "add") {
        // console.log("Emmited", value);
        this.$emit("addOk", value);
      } else if (this.formActionType === "edit") {
        // console.log("in edit form", value);
        let editArray = [];
        for (let i in value) {
          editArray.push(value[i]);
        }
        this.$emit("editOk", editArray);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  created() {
    if (this.formActionType === "add") {
      this.actionTypeName = this.$t('form.insert');
    } else this.actionTypeName = this.$t('form.edit');
    if (this.type === "server") {
      this.typeName = this.$t('form.server');
    } else if (this.type === "app") {
      this.typeName = this.$t('form.app');
    } else if (this.type === "db") {
      this.typeName = this.$t('form.dataBase');
    } else if (this.type === "app param") {
      this.typeName = this.$t('form.appParam');
    } else if (this.type === "user") {
      this.typeName = this.$t('form.user');
    } else if (this.type === "task") {
      this.typeName = this.$t('form.task');
    } else if (this.type === "role") {
      this.typeName = this.$t('form.role');
    }
  },
  components: {
    Server,
    mySection: Section,
    DBase,
    myParam: Param,
    User,
    Task,
    AppParam,
    Role,
  },
  computed: {
    ...mapGetters(["getConfigTree"]),
  },
};
</script>

<style>
</style>


<style scoped>
</style>